var linkThemeNative = {
  color: 'secondary',

  /**
   * Margin as defined in CSS margin property
   */
  margin: '4px 3px 12px 12px'
};
var linkThemeWeb = {
  color: 'secondary'
};
export { linkThemeNative, linkThemeWeb };